import { render, staticRenderFns } from "./BankCryptoAddEmptyCard.vue?vue&type=template&id=6aaa9fff&scoped=true"
import script from "./BankCryptoAddEmptyCard.vue?vue&type=script&lang=js"
export * from "./BankCryptoAddEmptyCard.vue?vue&type=script&lang=js"
import style0 from "./BankCryptoAddEmptyCard.vue?vue&type=style&index=0&id=6aaa9fff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaa9fff",
  null
  
)

export default component.exports